import {
  Component, ViewChild, Input, Output, EventEmitter, ViewContainerRef, ChangeDetectorRef
} from '@angular/core';
import { ModalDirective, ModalOptions } from 'ngx-bootstrap';

import { bodyScroll } from '../../../utils/utils';

// TODO: ld-tooltip & ld-modal will be replaced by ula-modal; this is a breaking change
@Component({
  selector: 'ld-modal',
  templateUrl: './ld-modal.template.html',
  styleUrls: [ './ld-modal.component.scss' ]
})
export class LDModalComponent {

  @ViewChild('ld_modal') _modal: ModalDirective;
  @ViewChild('ld_modal', {read: ViewContainerRef}) private _modalEl;

  @Input() disableFooter: boolean;
  @Input() disableHeader: boolean;
  @Input() disableCloseButton: boolean;
  @Input() cancelBtnDisabled: boolean;
  @Input() cancelBtnText: string;
  @Input() submitBtnDisabled: boolean;
  @Input() submitBtnText: string;
  @Input() backdropBehindModal = false;
  @Input() padding = true;
  @Input() isDocument = false;
  @Input() width: number; // depricated
  @Input() isErrorDialogModal = false;
  @Input() config: ModalOptions = null;

  private _ieHeightPatchNeeded = false;
  public showModal = false;

  @Output() cancel: EventEmitter<any> = new EventEmitter<any>();
  @Output() hidden: EventEmitter<any> = new EventEmitter<any>();
  @Output() submit: EventEmitter<any> = new EventEmitter<any>();
  @Output() shown: EventEmitter<any> = new EventEmitter<any>();

  constructor(private changeDetectorRef: ChangeDetectorRef) {
  }

  get modalContentStyle(): {height?: string} {
    const style: {height?: string} = {};
    if (!this._ieHeightPatchNeeded) {
      try {
        const ref = document.getElementsByClassName('modal-content')[0];
        if (ref.scrollHeight > (<any>ref).offsetHeight) {
          this._ieHeightPatchNeeded = true;
        }
      } catch (err) {
      }
    }
    if (this._ieHeightPatchNeeded) {
      let h = window.innerHeight;
      if (typeof h !== 'number') {
        const de = document.documentElement;
        h = de && de.clientHeight ? de.clientHeight : 780;
      }
      style.height = (h * 0.8) + 'px';
    }
    return style;
  }

  show() {
    this.showModal = true;
    this.backgroundCanScroll = false;
    setTimeout(() => {
      this.shown.emit(null);
      this.changeDetectorRef.markForCheck();
    }, 0);
  }

  hide() {
    this.backgroundCanScroll = true;
    this.showModal = false;
  }

  doSubmit() {
    this.backgroundCanScroll = true;
    this.hide();
    this.submit.emit(null);
  }

  doCancel() {
    this.backgroundCanScroll = true;
    this.hide();
    this.cancel.emit(null);
  }

  relayOnHidden($event) {
    this.backgroundCanScroll = true;
    this.hide();
    this.hidden.emit($event);
  }

  private set backgroundCanScroll(canScroll: boolean) {
    bodyScroll(canScroll);
  }
}
